export class BusinessTransactionOverrideResponse {
    constructor(businessTransactionOverrideId: number, isApproved: boolean) {
        this.businessTransactionOverrideId = businessTransactionOverrideId;
        this.isApproved = isApproved;
    }

    public businessTransactionOverrideId: number;
    public isApproved: boolean;
}
